import { Component, ElementRef, signal, viewChild } from '@angular/core';
import { DialogBackdropDirective } from "../directives/dialog-backdrop/dialog-backdrop.directive";

@Component({
  selector: 'image-preview',
  imports: [DialogBackdropDirective],
  templateUrl: './preview-image.component.html',
  styleUrl: './preview-image.component.scss',
})
export class PreviewImageComponent {
  // refs
  preview = viewChild<ElementRef<HTMLDialogElement>>('preview')

  // data
  image = signal<string>('')

  display(image: string) {
    this.image.set(image)
    this.preview()?.nativeElement.show();
  }

  dismiss() {
    this.preview()?.nativeElement.close();
    this.image.set('')
  }
}
